module.exports = __webpack_public_path__ + "img/xmas-bg.6dd7e7b.webp";